export const isFlashDrawActive = (flashDraw) => {
  if (!flashDraw) return false;
  const now = new Date();
  const startDate = new Date(flashDraw.startAt);
  const endDate = new Date(flashDraw.endAt);
  return now >= startDate && now <= endDate && flashDraw.isActive;
}
